import gql from 'graphql-tag';

const auctionLocationsQuery = gql`
  query auctionLocationsQuery($sortBy: String, $acceptsReturns: Boolean) {
    locations(sortBy: $sortBy, acceptsReturns: $acceptsReturns) {
      id
      initials
      name
      auctionedge_code
      partnerNetwork
      acceptsReturns
    }
  }
`;

export default auctionLocationsQuery;
